import { StripeSubscriptionPlan } from './stripe-subscription-plan.model';

export class StripeSubscriptionItem {
  id: string;
  metaData: any[];
  plan: StripeSubscriptionPlan;
  quantity: number;
}
